import script from "./j-tabs.vue?vue&type=script&lang=js"
export * from "./j-tabs.vue?vue&type=script&lang=js"

import "./j-tabs.vue?vue&type=style&index=0&id=dac0c4a0&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac0c4a0"]])

export default __exports__